/**
 * Admin Role Assignment Logic
 */
export function initRoles() {
    const modalRoleElem = document.getElementById('modalRole');
    if (!modalRoleElem) return;

    const modalRole = new bootstrap.Modal(modalRoleElem);
    const formRole = document.getElementById('formRole');
    const modalTitle = document.getElementById('modalRoleLabel');
    const userSelectField = document.getElementById('userSelectField');

    const btnOpenAssignRole = $('[data-bs-target="#modalRole"]');
    if (btnOpenAssignRole.length) {
        btnOpenAssignRole.on('click', function() {
            formRole.reset();
            formRole.action = this.dataset.urlStore;
            modalTitle.innerText = "Assign Role to User";
            if (userSelectField) userSelectField.classList.remove('d-none');
            $('.select2-modal').val('').trigger('change');
            modalRole.show();
        });
    }

    $(document).on('click', '.btn-edit-assignment', function() {
        const id = $(this).data('id');
        const urlJson = $(this).data('url-json');
        const urlUpdate = $(this).data('url-update');
        
        Swal.fire({ title: 'Loading...', didOpen: () => { Swal.showLoading(); } });

        $.get(urlJson, function(data) {
            Swal.close();
            formRole.action = urlUpdate;
            modalTitle.innerText = `Update Role: ${data.username}`;
            if (userSelectField) userSelectField.classList.add('d-none');
            
            $('#group').val(data.group).trigger('change');
            modalRole.show();
        });
    });

    $(document).on('click', '.btn-revoke-role', function(e) {
        e.preventDefault();
        const form = $(this).closest('form');
        Swal.fire({
            title: 'Revoke Role Access?',
            text: "This user will lose the permissions associated with this role.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            confirmButtonText: 'Yes, Revoke'
        }).then((result) => {
            if (result.isConfirmed) form.submit();
        });
    });
}
